import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import ReactGA from 'react-ga';

import App from './containers/App';
// import unregister from './registerServiceWorker';
import configureStore from './configureStore';
import getInitialState from './getInitialState';
import startSocket from './middleware/socket';
import fixChromeHash from './utils/fixChromeHash';

const history = createHistory();
const initialState = getInitialState();
const store = configureStore(history, initialState);

history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

fixChromeHash();

// Start the socket connection.
startSocket(store);

render((
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </Provider>
  ), document.getElementById('root'));

// Don't register a SW for now
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js